<template>
	<div class="game">
		<!-- <p>Is mobile: {{ isMobile }}</p> -->

		<Preload v-if="status === 'preload'" />

		<Started @startGame="startGame" v-if="status === 'started'" />

		<!-- Game in three different modes -->

		<CalcMode
			v-if="isShowCalcMode"
			:isAbacusMode="isAbacusMode"
			:isSmallFont="false"
			:calcMethod="calcMethod"
			:isHomework="isHomework"
		/>

		<template v-if="status === 'numbers'">
			<Columns
				:gameDataIds="gameDataIds"
				:isHomework="isHomework"
				v-if="isColumnsMode"
				:initialTimer="+gameConfig.timerCount"
				:isTimerEnabled="gameConfig.isTimerEnabled"
				:columnNumbers="columnNumbers"
				:rightColumnAnswers="rightColumnAnswers"
				:users="gameConfig.users"
				:gameType="gameConfig.digit_type || gameConfig.type"
				@onSubmitAllColumns="onSubmitAllColumns"
			/>

			<AbacusRandom
				v-else-if="isAbacusMode"
				:numbers="numbers"
				@onGameEnds="onGameEnds"
			/>

			<Numbers
				v-else
				:isSmallFont="
					gameConfig.type === 'multiply' ||
						gameConfig.type === 'multiply_quad' ||
						gameConfig.type === 'divide'
				"
				:calcMethod="calcMethod"
				:isHomework="isHomework"
				:number="number"
			/>
		</template>

		<Answer
			@checkAnswer="val => checkAnswer(val)"
			:isAbacusMode="isAbacusMode"
			:expression="expression"
			v-if="status === 'answer'"
		/>

		<Result
			v-if="status === 'result'"
			:columnResults="columnResults"
			:isColumnsMode="isColumnsMode"
			:expression="expression"
			:answer="answer"
			:showTryAgain="showTryAgain"
			:notHomework="!isHomework"
			:statusAnswer="statusAnswer"
			:currentExpression="currentExpression"
			:tasksLeft="tasksLeft"
			:isTrain="isTrain"
			@startGame="startGame"
			@loadGame="loadGame"
		/>

		<GameVideo
			@close="showVideo = false"
			v-if="showVideo"
			:show="showVideo"
			:video="video"
		></GameVideo>

		<div
			v-if="isDemo && ['answer', 'numbers'].includes(status)"
			class="demo-abacus"
		>
			<Abacus isDemo="true" />
		</div>
	</div>
</template>

<script>
import Started from './Started'
import Answer from './Answer'
import Preload from '@/components/Preloader.vue'
import Result from './Result'
import Numbers from './Numbers'
import Columns from './Columns'
import AbacusRandom from './AbacusRandom'
import GameVideo from './Video'
import { Howl, Howler } from 'howler'
import { Mode } from '../gameConfig'
import Abacus from './Abacus'
import CalcMode from './CalcMode.vue'

export default {
	name: 'game',
	data() {
		return {
			taskColumn: 0,
			isTrain: false,
			rightColumnAnswers: {},
			columnResults: [],
			columnNumbers: [],
			status: 'preload',
			countGame: 0,
			answer: '',
			statusAnswer: '',
			expression: '',
			showTryAgain: true,
			playlist: [],
			numbers: [],
			currentExpression: 0,
			isIOS: false,
			audioCount: 0,
			number: 3,
			mulOrDiv: null,
			calcMethod: null, // check for uselessness
			tasksLeft: null,
			intervalId: null,
			timeoutId: null,
			gameDataId: null,
			gameDataIds: null,
			video: null,
			showVideo: false,
			playedSound: null,
		}
	},
	components: {
		Started,
		Preload,
		Numbers,
		AbacusRandom,
		Result,
		Answer,
		GameVideo,
		Abacus,
		Columns,
		CalcMode,
	},

	methods: {
		resetSettings(fullReset) {
			if (fullReset) {
				this.gameDataId = null
				this.gameDataIds = []
				this.status = 'preload'

				if (this.gameConfig.withSound) {
					this.successAudio.volume(0)
				}
			}
			this.playlist = []
			this.numbers = []
			this.columnNumbers = []
			this.currentExpression = 0
			this.answer = ''
			this.tasksLeft = 0
			this.showTryAgain = false
		},

		loadSound(gameItems) {
			// Load all sound and wrap it into Howl, for fix IOS audio bug
			const createAudio = audio =>
				new Howl({ src: [audio], html5: !this.isMobile, preload: true })

			if (
				this.gameConfig.withSound &&
				!this.mulOrDiv &&
				!this.isColumnsMode &&
				!this.isAbacusMode
			) {
				const sounds = [...gameItems]
					.map(i => `${i.sign}${i.number}`)
					.filter((element, index, array) => {
						return array.indexOf(element) === index
					})

				const howlList = {}

				sounds.forEach(i => {
					howlList[i] = createAudio(
						`https://assets.indigomental.com/audio/numbers/${this.lng}/${Number(
							i
						)}.mp3?v=1`
					)
				})

				for (let sound in gameItems) {
					try {
						this.playlist.push(
							howlList[String(gameItems[sound].sign + gameItems[sound].number)]
						)
					} catch (e) {
						this.playlist.push(null)
						// console.error('Error on loading audio: ', e)
					}
				}
				this.playlist.push(
					createAudio('https://assets.indigomental.com/audio/3_2_1.mp3')
				)
			}
			// Load random success sound. This sound is required for each game, regardless `withSound` config
			this.playlist.push(
				createAudio(
					`https://assets.indigomental.com/audio/congrats/${parseInt(
						Math.random() * 28 + 1
					)}.mp3?v=1`
				)
			)
			// Display started screen
			this.status = 'started'
		},

		localGenerateData(config) {
			let gameItems = []

			// if (config.type === 'multiply_base') {
			// 	const random = number => {
			// 		if (number === 100) {
			// 			return parseInt(Math.random() * (111 - 91) + 90)
			// 		} else if (number === 50) {
			// 			return parseInt(Math.random() * (60 - 42) + 41)
			// 		}
			// 	}
			// 	// Simulate game server response
			// 	for (let i = 0; i < config.length; i++) {
			// 		gameItems.push({
			// 			number: random(config.complexity),
			// 			sign: '+',
			// 		})
			// 		gameItems.push({
			// 			number: random(config.complexity),
			// 			sign: '*',
			// 		})
			// 	}
			// } else

			if (config.type === 'multiply_25x25') {
				const numbersList = [15, 25, 35, 45, 55, 65, 75, 85, 95]

				let currentNumber =
					numbersList[Math.floor(Math.random() * numbersList.length)]

				// const random = number => {
				// 	if (number === 100) {
				// 		return parseInt(Math.random() * (111 - 91) + 90)
				// 	} else if (number === 50) {
				// 		return 25
				// 	}
				// }

				// Simulate game server response
				for (let i = 0; i < config.length; i++) {
					gameItems.push({
						number: currentNumber,
						sign: '+',
					})
					gameItems.push({
						number: currentNumber,
						sign: '*',
					})
				}
			} else if (config.type === 'multiply_quad') {
				const random = parseInt(
					Math.random() * (config.numbers[1] - config.numbers[0] + 1) +
						config.numbers[0]
				)
				// Simulate game server response
				for (let i = 0; i < config.length; i++) {
					gameItems.push({
						number: random,
						sign: '+',
					})
					gameItems.push({
						number: random,
						sign: '*',
					})
				}
			}

			return gameItems
		},

		async generateGame(config) {
			const operations = []
			const digits = []
			let generatedGame
			let gameItems = []

			// console.log('config', config)

			// We generate gamedata for multiply_base and multiply_quad ourself
			if (config.type === 'multiply_base') {
				const random = number => {
					if (number === 100) {
						return parseInt(Math.random() * (111 - 91) + 90)
					} else if (number === 50) {
						return parseInt(Math.random() * (60 - 42) + 41)
					}
				}
				// Simulate game server response
				for (let i = 0; i < config.length; i++) {
					gameItems.push({
						number: random(config.complexity),
						sign: '+',
					})
					gameItems.push({
						number: random(config.complexity),
						sign: '*',
					})
				}
			} else if (config.type === 'multiply_25x25') {
				const numbersList = [15, 25, 35, 45, 55, 65, 75, 85, 95]

				let currentNumber =
					numbersList[Math.floor(Math.random() * numbersList.length)]

				// const random = number => {
				// 	if (number === 100) {
				// 		return parseInt(Math.random() * (111 - 91) + 90)
				// 	} else if (number === 50) {
				// 		return 25
				// 	}
				// }

				// Simulate game server response
				for (let i = 0; i < config.length; i++) {
					gameItems.push({
						number: currentNumber,
						sign: '+',
					})
					gameItems.push({
						number: currentNumber,
						sign: '*',
					})
				}
			} else if (config.type === 'multiply_quad') {
				const random = parseInt(
					Math.random() * (config.numbers[1] - config.numbers[0] + 1) +
						config.numbers[0]
				)
				// Simulate game server response
				for (let i = 0; i < config.length; i++) {
					gameItems.push({
						number: random,
						sign: '+',
					})
					gameItems.push({
						number: random,
						sign: '*',
					})
				}
			} else {
				if (config.type === 'anzan') {
					config.type = config.digit_type

					// config.places = null
				} else if (config.type === 'anzan_minus') {
					// console.log("ANZAN MINUS !!!")

					config.digit = 0
				}

				// console.log('config 2', config)

				const getGame = async () =>
					await this.axios
						.post(
							`https://${
								process.env.VUE_APP_ENV == 'dev' ? 'games.dev' : 'algos'
							}.indigomental.com/`, //
							JSON.stringify({
								...config,
								...(this.$store?.state?.myProfile?.id
									? { user_id: this.$store.state.myProfile.id }
									: {}),
							}),
							{
								headers: {
									'Content-Type': 'application/json',
									// @see src/main
									// it resets `Authorization` header.
									'No-Auth': '',
								},
							}
						)
						.catch(error => {
							console.error(error)
						})
				/** Parse our items data from query */
				if (this.isColumnsMode) {
					const requestedGames = await Promise.all(
						this.gameConfig.users.reduce((arr, i) => [...arr, getGame()], [])
					)

					this.columnNumbers = requestedGames.map(resp =>
						resp.data.items.map(({ number, sign }) => `${sign}${number}`)
					)
				} else {
					// Generate game
					generatedGame = await getGame()
					gameItems = generatedGame.data.items
				}
			}

			const isManuallyGenerated =
				config.type == 'multiply_25x25' || config.type == 'multiply_quad'

			console.log(gameItems)

			if (this.isColumnsMode && isManuallyGenerated) {
				const requestedGames = await Promise.all(
					this.gameConfig.users.reduce(
						(arr, i) => [...arr, this.localGenerateData(config)],
						[]
					)
				)

				this.columnNumbers = requestedGames.map(resp =>
					resp.map(({ number, sign }) => `${sign}${number}`)
				)
			}

			if (!this.isColumnsMode) {
				// Parse generated game, for creating game on backend
				gameItems.forEach(item => {
					const { number, sign } = item
					digits.push(number)
					operations.push(sign)
					this.numbers.push(`${sign}${number}`)
				})
			}

			// If game data id is null - create new game for user on backend
			if (!this.isDemo && this.gameDataId === null) {
				let type = 'addition'
				if (config.type.indexOf('abacus_random') >= 0) {
					type = 'abacus_random'
				} else if (config.type.indexOf('anzan') >= 0) {
					type = 'anzan'
				} else if (config.type.indexOf('mul') >= 0) {
					type = 'multiply'
				} else if (config.type === 'divide') {
					type = 'divide'
				} else if (config.type === 'negative') {
					type = 'negative'
				}

				if (this.isColumnsMode) {
					const responses = await Promise.all(
						this.columnNumbers.map(column => {
							const columnParsed = column.map(item => ({
								sign: item[0],
								number: Number(item.slice(1)),
							}))

							return this.axios({
								method: 'post',
								url: 'lessons/games',
								data: {
									digit_type: config.type,
									speed: config.speed,
									difficult: config.places,
									operation_number: columnParsed.length,
									calculation_method: 'oral',
									is_muted: config?.withSound ? false : true,
									numbers: columnParsed.map(i => i.number),
									user: this.$store.state.myProfile.id,
									type,
									operations: columnParsed.map(i => i.sign),
									with_columns: true,
								},
							})
						})
					)

					this.gameDataIds = responses
						.map(resp => resp?.data?.data?.[0]?.id)
						.filter(Boolean)
					this.gameDataId = this.gameDataIds?.[0] || null
				} else {
					const resp = await this.axios({
						method: 'post',
						url: 'lessons/games',
						data: {
							digit_type: config.type,
							speed: config.speed,
							difficult: config.places,
							operation_number: gameItems.length,
							calculation_method: 'oral',
							is_muted: config?.withSound ? false : true,
							numbers: digits,
							user: this.$store.state.myProfile.id,
							type,
							operations,
						},
					})
					this.gameDataId = resp.data.data[0].id
				}
			}

			this.loadSound(gameItems)
		},

		async loadGame(next) {
			/**
			 * @description
			 * Main function, will fire on creating page and on every starting of new game.
			 * It will get game config from homework or training page and build config for game server.
			 * Also here will call load of sounds, resetting all previous changes.
			 *
			 * There are will be two types of game:
			 * 1) Sub/sum - more than one operation will display on screen
			 * 2) Div/mul - one operation will display with the expression on the screen
			 *
			 * Divide and multiply will have only one operation and it will be set here only
			 * If something change - please, update this description
			 */
			// Set all settings to default
			this.rightColumnAnswers = []
			this.resetSettings(next)
			let config = {}
			// If this is homework - request config from API
			if (this.gameConfig.homework) {
				const homework = await this.axios({
					method: 'get',
					url: `lessons/homeworks/${this.gameConfig.homework}?user=${this
						.gameConfig.read_only || this.$store.state.myProfile.id}`,
				})

				// console.log(this.gameConfig.read_only)

				/**
				 * Remove gameData with right answer
				 * Remove game objects with empty data Array
				 * Calc amount of unsolved tasks
				 */

				homework.data.games = homework.data.games.filter(game => {
					if (game.with_columns && game.data.some(el => !el.is_right_answer)) {
						this.tasksLeft++
					}
					if (!game.with_columns) {
						game.data = game.data.filter(data => {
							if (!data.is_right_answer) {
								this.tasksLeft++
								return data
							}
						})
					}

					if (game.with_columns && game.data.some(e => !e.is_right_answer)) {
						return game
					}

					if (game.data.length > 0 && !game.with_columns) {
						return game
					}
				})
				// backend based data type
				const homeworkConfig = homework.data.games[0].data[0]
				const isColumns = homework.data.games[0]?.with_columns
				this.calcMethod = homeworkConfig.calculation_method
				// if student -- assign game`s id
				// if (this.$store.state.myProfile.role === 'student') {
				this.gameDataId = homeworkConfig.id
				// }
				if (isColumns) {
					console.log('homework data', homework.data.games)
					this.gameDataIds = homework.data.games[0].data?.map(el => el.id)
					// Always start homework columns with a fresh input state.
					this.rightColumnAnswers = {}
				}

				// If speed wasn`t changed on homework page
				if (!this.gameConfig.changedSpeed) {
					const payload = {
						...this.gameConfig,
						speed: homeworkConfig.speed,
						digit_type: homeworkConfig.digit_type,
					}
					if (isColumns) {
						payload.users =
							homework.data.games[0].data?.reduce(acc => [...acc, ''], []) ?? []

						if (homework?.data?.games[0]?.game_data) {
							const newTimer = JSON.parse(homework.data.games[0].game_data)

							payload.isTimerEnabled = newTimer.isTimerEnabled
							payload.timerCount = Number(newTimer.timerCount)
						}
					}

					this.$store.commit('changeGameConfig', payload)
				}
				// Construct config for Game Server
				config.type = homeworkConfig.digit_type
				config.length = +homeworkConfig.operation_number || 1
				config.places = null
				config.digit = null
				config.complexity = null
				config.numbers = null
				config.pro = homeworkConfig?.option == 'pro'

				this.$store.commit('changeGameConfig', {
					...this.gameConfig,
					type: homeworkConfig.type,
					digit_type: homeworkConfig.digit_type,
					mode: isColumns
						? Mode.columns
						: homeworkConfig.type === 'abacus_random'
						? Mode.abacus
						: Mode.digits,
				})

				if (homeworkConfig.type == 'abacus_random') {
					console.log('abacus RANDOM !')
					config = {
						digits: JSON.parse(homeworkConfig.option),
						type: 'abacus_random_2',
						length: +homeworkConfig.operation_number || 1,
					}

					// type: this.gameConfig.type,
					// 	length: +this.gameConfig.length || 1,
					// 		digits: this.gameConfig.digit
				}

				if (config.type === 'divide') {
					config.numbers = [
						+homeworkConfig.difficult,
						+homeworkConfig.difficult_2,
					]
				}

				if (config.type === 'multiply') {
					config.places = +homeworkConfig.difficult
				}

				if (config.type === 'multiply_50_100') {
					config.digit = +homeworkConfig.difficult
					config.mode = homeworkConfig.option
				}

				if (config.type === 'multiply_quad' || config.type === 'multiply') {
					console.log('Homework Config', homeworkConfig)
					config.numbers = homeworkConfig.numbers.map(Number)
				}

				// addition or anzan
				if (
					[
						'elementary',
						'small_friends',
						'big_friends',
						'family',
						'fifty',
						'hundred',
						'anzan_random',
						'anzan_plus',
						'anzan_minus',
						'negative',
						'anzan',
					].includes(config.type)
				) {
					config.places = Number(homeworkConfig.difficult)

					// console.log("digit:", homeworkConfig.digit !== null && homeworkConfig.digit !== undefined
					// 	? Number(homeworkConfig.digit)
					// 	: null)

					config.digit =
						homeworkConfig.digit !== null && homeworkConfig.digit !== undefined
							? Number(homeworkConfig.digit)
							: null /* null will for anzan */

					config.complexity = +homeworkConfig.difficult
				}
			} else {
				/* If it is simple training */
				config =
					this.gameConfig.type == 'abacus_random_2'
						? {
								type: this.gameConfig.type,
								length: +this.gameConfig.length || 1,
								digits: this.gameConfig.digit,
						  }
						: {
								type: this.gameConfig.type,
								length: +this.gameConfig.length || 1,
								places: +this.gameConfig.places,
								digit: +this.gameConfig.digit,
								complexity: +this.gameConfig.complexity,
								numbers: this.gameConfig.numbers
									? this.gameConfig.numbers.map(n => +n)
									: null,
								pro: this.gameConfig.pro || false,
								mode: this.gameConfig.mode || null,
						  }
			}

			this.mulOrDiv =
				config.type === 'multiply' ||
				config.type === 'multiply_base' ||
				config.type === 'multiply_50_100' ||
				config.type === 'multiply_25x25' ||
				config.type === 'divide' ||
				config.type === 'multiply_quad'
			await this.generateGame(config)
		},

		startGame(nextExpression) {
			/**
			 * @description
			 * Fire, when user click on start button
			 * Reset previous changes
			 *
			 * If game have multiply or divide type - display expression with answer input
			 *
			 * If not -> display counter and flash digits with setting interval (speed value) and play sound
			 * After that, display answer input
			 */

			// Keep prefilled correct columns only for "Try again" (status === 'result').
			// A regular "Start" should always begin with empty inputs.
			if (this.isColumnsMode && this.status !== 'result') {
				this.rightColumnAnswers = {}
			}

			this.answer = ''
			this.expression = ''
			if (this.mulOrDiv && !this.isColumnsMode) {
				this.status = 'answer'
				this.expression = `${+this.numbers[0]} ${
					this.gameConfig.type === 'divide' ? '/' : '×'
				} ${
					this.gameConfig.type === 'multiply_quad'
						? +this.numbers[0]
						: `${this.numbers[1]}`.slice(1)
				}`
			} else if (!this.isColumnsMode && !this.isAbacusMode) {
				// For all base game types. We show numbers with certain speed, and after last digit show answer input
				const speed = this.gameConfig.speed
				const speedInMs = speed * 1000
				// console.log('speed', this.gameConfig.speed)
				const withSound =
					this.gameConfig.withSound && this.gameConfig.speed >= 1
				// console.log('sound', this.gameConfig.withSound)
				this.audioCount = 0
				this.number = 3
				if (withSound) {
					console.log('start audio', this.successAudio)

					this.successAudio.volume(0)
				}
				if (nextExpression) {
					this.currentExpression += 1
					this.number = ''
				}

				this.status = 'numbers'
				this.$nextTick(() => {
					const numberStyle =
						document.querySelectorAll('.number')[0]?.style || {}
					if (withSound) {
						try {
							this.initialAudio.volume(0.03)
							this.initialAudio.play()
						} catch (error) {
							console.log(error)
						}
					}

					// 1, 2, 3... Go
					setTimeout(() => {
						this.number = 2
					}, 1000)
					setTimeout(() => {
						this.number = 1
					}, 2000)
					setTimeout(() => {
						this.number = 'GO'
					}, 3000)
					setTimeout(() => {
						this.number = ''
					}, 4000)

					this.timeoutId = setTimeout(() => {
						this.intervalId = setInterval(() => {
							if (this.audioCount < this.numbers.length) {
								setTimeout(() => {
									this.number = ''
								}, speedInMs - 200)

								this.number = this.numbers[this.audioCount]

								if (withSound) {
									try {
										if (!this.isMobile) {
											const duration = this.playlist[
												this.audioCount
											]?.duration()
											if (speed < duration) {
												this.playlist[this.audioCount]?.rate(duration / speed)
											}
										}

										this.playlist[this.audioCount]?.play()
									} catch (error) {
										console.log(error)
									}
								}

								this.audioCount++
							} else {
								this.onGameEnds()
								clearInterval(this.intervalId)
							}
						}, speedInMs)
					}, 5000 - speedInMs)
				})
			} else {
				this.status = 'numbers'
			}
		},

		onGameEnds() {
			this.animate = false
			this.status = 'answer'
			this.number = 3
		},

		checkAnswer(answer, id) {
			let result = ''

			// console.log('Answer: ', answer)

			const type = this.gameConfig.type
			if (
				type === 'multiply' ||
				type === 'multiply_base' ||
				type === 'multiply_50_100' ||
				type === 'multiply_25x25'
			) {
				result = this.numbers[0] * this.numbers[1].slice(1)
			} else if (type === 'divide') {
				result = parseInt(Number(this.numbers[0]) / this.numbers[1].slice(1))
			} else if (type === 'multiply_quad') {
				result = Math.pow(this.numbers[0], 2)
			} else if (this.isAbacusMode) {
				result = 0 + Math.abs(Number(this.numbers[this.numbers.length - 1]))

				// console.log('Raw number: ', this.numbers[this.numbers.length - 1])
				// console.log('Result: ', result)
			} else {
				result = this.numbers.reduce((sum, current) => {
					return sum + Number(current)
				}, 0)
				this.expression = `${this.numbers.join('')} `
			}

			if (!this.isHomework) this.expression += ` = ${result}`

			this.status = 'result'
			this.answer = answer
			this.showTryAgain = !(result === Number(answer))
			if (result === Number(answer)) {
				this.statusAnswer = 'win'

				try {
					this.successAudio.volume(0.05)

					this.playedSound = this.successAudio.play()
				} catch (error) {
					console.log(error)
				}

				window.localStorage.setItem('success_puzzle', this.gameConfig.homework)
			} else {
				this.statusAnswer = 'lose'
			}

			if (!this.isDemo && !this.gameConfig.read_only) {
				this.axios({
					method: 'PATCH',
					url: `lessons/game/data/${id || this.gameDataId}`,
					data: {
						answer: result,
						is_right_answer: answer === '' ? false : result === Number(answer),
					},
				}).then(apiAnswer => {
					// console.log("is right:", apiAnswer.data.is_right_answer)

					const isRightAnswer = apiAnswer?.data?.is_right_answer

					if (answer !== '' && result === Number(answer)) {
						let totalPlayed = window.localStorage.getItem('totalPlayed')
						totalPlayed = Number(totalPlayed) + 1

						window.localStorage.setItem('totalPlayed', totalPlayed)

						if (isRightAnswer) {
							const oldRightAnswers = window.localStorage.getItem('totalRight')

							const newRightAnswers = Number(oldRightAnswers) + 1

							window.localStorage.setItem('totalRight', newRightAnswers)
						}

						window.localStorage.setItem(
							'success_puzzle',
							this.gameConfig.homework
						)
						if (totalPlayed % 20 === 0) {
							this.axios({
								method: 'GET',
								url: `https://api.indigomental.com/v1/videos/`,
							}).then(res => {
								this.video = res.data.data
								this.showVideo = true
							})
						}
					}
				})
			}
		},

		async checkAnswerColumn(answers) {
			if (this.gameConfig.read_only) return

			const data = answers
				.filter(item => item?.id !== null && item?.id !== undefined)
				.map(item => ({
					id: item.id,
					answer: item.answer ?? null,
					is_right_answer: item.is_right_answer ?? false,
				}))

			if (!data.length) return

			await this.axios({
				method: 'POST',
				url: 'lessons/game/data/set_columns_answers',
				data,
			})
		},

		async onSubmitAllColumns(columnResults, isTrain) {
			this.columnResults = columnResults
			this.showTryAgain = columnResults.some(el => !el?.correct ?? false)

			const rightAnswers = {}

			columnResults.forEach((el, index) => {
				if (el.correct) {
					const key = isTrain ? `${el.userId}${index}` : `${el.userId}`
					rightAnswers[key] = el.answer
				}
			})

			this.rightColumnAnswers = rightAnswers

			if (columnResults.every(el => el?.correct ?? false)) {
				this.statusAnswer = 'win'

				try {
					this.successAudio.volume(0.05)
					this.playedSound = this.successAudio.play()
				} catch (error) {
					console.log(error)
				}

				window.localStorage.setItem('success_puzzle', this.gameConfig.homework)
			} else {
				this.statusAnswer = 'lose'
			}

			if (isTrain) {
				this.isTrain !== isTrain && (this.isTrain = isTrain)
			}

			const shouldSaveAnswers =
				!isTrain ||
				(isTrain &&
					Array.isArray(this.gameDataIds) &&
					this.gameDataIds.length > 0)

			if (shouldSaveAnswers) {
				const answers = []

				columnResults.forEach(result => {
					answers.push({
						id: result?.userId,
						answer: result?.answer ?? null,
						is_right_answer: result?.correct ?? false,
					})
				})

				await this.checkAnswerColumn(answers)
				if (!isTrain) {
					this.taskColumn++
				}
			}

			this.status = 'result'
		},
	},
	computed: {
		isShowCalcMode() {
			return (
				(this.status == 'numbers' || this.status == 'answer') &&
				!this.isAbacusMode
			)
		},

		isColumnsMode() {
			// @see defaultGameConfig.columns
			// now actual only for /games/columns

			return (
				this.gameConfig.mode === Mode.columns ||
				this.gameConfig.isMultiplyColumn
			)
		},
		isDemo() {
			return this.$route.path.startsWith('/demo')
		},

		isMobile() {
			const regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
			return regex.test(navigator.userAgent)
		},

		lng() {
			// If user make homework or by any way pass language to gameConfig - use it or use selected and stored language
			return (
				this.gameConfig.language ||
				require('../gameConfig.ts').getConfig(undefined, !this.isDemo).language
			)
		},

		successAudio() {
			return this.playlist[this.playlist.length - 1]
		},

		initialAudio() {
			return this.playlist[this.playlist.length - 2]
		},

		gameConfig() {
			// check for uselessness
			return this.$store.state.gameConfig
		},

		isAbacusMode() {
			// check for uselessness
			return this.gameConfig?.mode === Mode.abacus
		},
		isHomework() {
			return !!this.gameConfig.homework
		},
	},

	watch: {
		playlist() {
			if (this.playedSound) {
				try {
					Howler.stop(this.playedSound)

					this.playedSound = null
				} catch (error) {
					console.log(error)
				}
			}
		},
	},

	created() {
		this.isIOS =
			!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
		this.loadGame()
	},
	beforeDestroy() {
		this.$store.commit('changeGameConfig', {})
		clearInterval(this.intervalId)
		clearTimeout(this.timeoutId)

		try {
			for (let audio in this.playlist) this.playlist[audio]?.volume(0)
		} catch (error) {
			console.log(error)
		}
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app .game {
	position: relative;
	min-height: calc(100vh - 150px);
	text-align: center;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	justify-content: center;
	align-content: stretch;
	align-items: center;
}

@media (max-width: 576px) {
	#app .game {
		flex-direction: column;
	}
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	margin: 10px 0;
	width: 260px;
	cursor: pointer;
}

.btn-pink:hover {
	background-color: #e85183;
}
</style>
